import * as React from "react";
import { NavLink } from "react-router-dom";
import { MenuIcon, SideMenuIcon } from "../../../../assets/images/svg/SideMenuIconCollection";
import { ThemeConstants } from "../../../../../src/Core/Common/Constants";
import { ISideMenuItem } from "../../../../../src/Core/ViewModels/SideMenu/SideMenuModel";
import { dialogRoutes } from "../../../../../src/helper/Constants";
import { toogleMessageHistoryDialog } from "../../../../../src/helper/HelperFunctions";


export interface ISideMenuItemProps extends ISideMenuItem {
    onSelectMenu(menu: string): void;
}

export interface ISideMenuItemState {
    toggleClass: string | null;
}

export interface SubMenuItem {
    caption: string;
    route: string;
    icon: string;
    default: boolean;
    isDialogItem?: boolean;
}

export const MenuItem: React.FC<ISideMenuItemProps> = props => {
    const [state, setState] = React.useState<ISideMenuItemState>({
        toggleClass: null,
    });

    React.useEffect(() => {
        setState({ ...state, toggleClass: !props.active ? null : "show" });
    }, [props.active]);

    const handleSelectMenu:React.MouseEventHandler<HTMLAnchorElement> = (e) => {
        if(!props.disabled){
            props.onSelectMenu(props.caption);
        }else {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    const handleDialogSubMenuItemClick = (value:ISideMenuItem,e:React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if(!value.disabled){
            props.onSelectMenu(value.caption);
            toogleMessageHistoryDialog(value.caption);
        }else {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    return props.items.length > 0 ? (
        <li 
            className={["nav-item layout-dropdown ",state.toggleClass,props.disabled && "disable"].join(" ")}
            title={props.title}
        >
            <span
                onClick={() => {
                    !props.disabled && props.onSelectMenu(props.caption);
                }}
                className="nav-link layout-dropdown-toggle"
                id="pageslayout-dropdown"
                role="button"
                data-bs-toggle="layout-dropdown"
            >
                {(props.icon && props.icon.startsWith("fas")) || props.icon.startsWith("far") ? (
                    <i className={props.icon}></i>
                ) : (
                    <SideMenuIcon
                        icon={props.icon as MenuIcon}
                        color={ThemeConstants.SIDEMENU_ICON_COLOR}
                        width={16}
                        height={16}
                    ></SideMenuIcon>
                )}
                <span>{props.caption}</span>
            </span>
            <div
                className={"layout-dropdown-menu auto-resize-nav " + state.toggleClass}
                aria-labelledby="pageslayout-dropdown"
            >
                {props.items.length > 0 && props.items.map(value => {
                    return dialogRoutes.includes(value.caption) ? (
                        <a
                            className={["layout-dropdown-item", value.disabled && "disable"].join(" ")}
                            title={value.title}
                            onClick={(e)=>handleDialogSubMenuItemClick(value,e)}
                        >
                            <SideMenuIcon
                                icon={value.icon as MenuIcon}
                                color={ThemeConstants.SIDEMENU_ICON_COLOR}
                                width={16}
                                height={16}
                            ></SideMenuIcon>
                            <span> {value.caption}</span>
                        </a>
                    ) : (
                        <NavLink
                            key={value.route}
                            className={["layout-dropdown-item",props.disabled && "disable"].join(" ")}
                            to={value.route}
                            onClick={(e) => { 
                                if(props.disabled){
                                    e.preventDefault();
                                    e.stopPropagation;
                                }}}
                            title={props.title}
                        >
                            {value.icon && <i className={"sub-menu-icon " + value.icon}></i>}
                            {(value.icon && value.icon.startsWith("fas")) || value.icon.startsWith("far") ? (
                                <i className={value.icon}></i>
                            ) : (
                                <SideMenuIcon
                                    icon={value.icon as MenuIcon}
                                    color={ThemeConstants.SIDEMENU_ICON_COLOR}
                                    width={16}
                                    height={16}
                                ></SideMenuIcon>
                            )}
                            <span> {value.caption}</span>
                        </NavLink>
                    );
                })}
            </div>
        </li>
    ) : (
        <li
            className={"nav-item layout-dropdown " + state.toggleClass}
            onMouseLeave={() => {
                document.getElementsByClassName("toggled")[0] && setState({ ...state, toggleClass: null });
            }}
            onMouseEnter={() => {
                document.getElementsByClassName("toggled")[0] && setState({ ...state, toggleClass: "show" });
            }}
        >
            <NavLink
                onClick={handleSelectMenu}
                key={`${props.caption}-${props.route}`}
                to={props.route}
                title={props.title}
                className={["nav-link", props.active && "activeMenu", props.disabled && "disable"].join(" ")}
                id="pageslayout-dropdown"
                role="button"
                data-bs-toggle="layout-dropdown"
            >
                {(props.icon && props.icon.startsWith("fas")) || props.icon.startsWith("far") ? (
                    <i className={props.icon}></i>
                ) : (
                    <SideMenuIcon
                        icon={props.icon as MenuIcon}
                        color={ThemeConstants.SIDEMENU_ICON_COLOR}
                        width={16}
                        height={16}
                    ></SideMenuIcon>
                )}
                <span>{props.caption}</span>
            </NavLink>
        </li>
    );
};
export default MenuItem;
